// import React from 'react';
import axios from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/hoteles';

const hotelesApi = {
    crear: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/crear`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Si el backend devuelve [rows, fields] (MySQL2 raw) retornar rows; si ya es array directo, retornarlo tal cual
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching informacion de creacion de hotel:', error);
            return [];
        }
    },

    editar: async (id: string) => {
        try {
            const response = await axios.get(`${BASE_URL}/editar/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Si el backend devuelve [rows, fields] (MySQL2 raw) retornar rows; si ya es array directo, retornarlo tal cual
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching informacion de hotel:', error);
            return [];
        }
    },

    detalle: async (id: string) => {
        try {
            const response = await axios.get(`${BASE_URL}/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Si el backend devuelve [rows, fields] (MySQL2 raw) retornar rows; si ya es array directo, retornarlo tal cual
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching informacion de hotel:', error);
            return [];
        }
    },

    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Si el backend devuelve [rows, fields] (MySQL2 raw) retornar rows; si ya es array directo, retornarlo tal cual
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching activos:', error);
            return [];
        }
    },

    crearUsuarioHotel: async (data: { UsuarioId: number | string; HotelId: number | string; CreatedDate: string; LastModifiedDate: string }) => {
        const response = await axios.post(
            `https://inventariosbackend.velasresorts.com/inventarios/usuarioshoteles/crear`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );
        return response.data;
    },

    listadoUsuariosHoteles: async () => {
        try {
            const response = await axios.get(`https://inventariosbackend.velasresorts.com/inventarios/usuarioshoteles/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Si el backend devuelve [rows, fields] (MySQL2 raw) retornar rows; si ya es array directo, retornarlo tal cual
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching activos:', error);
            return [];
        }
    },

    darBajaUsuarioHotel: async (id: number | string) => {
        const response = await axios.put(
            `https://inventariosbackend.velasresorts.com/inventarios/usuarioshoteles/baja/${id}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );
        return response.data;
    },

    baja: async (id: string) => {
        try {
            const response = await axios.get(`${BASE_URL}/baja/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Si el backend devuelve [rows, fields] (MySQL2 raw) retornar rows; si ya es array directo, retornarlo tal cual
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching informacion de hotel:', error);
            return [];
        }
    }
};

export default hotelesApi;